export const environment = {
    production: true,

    baseUrl: 'https://test-assets.trask.cz/be',
    oidcApple: {
        clientId: 'com.jtfg.assets.akc.web',
        redirectUrl: 'https://test-assets.trask.cz/be/oidc/apple/callback',
    },
    loginApiService: {
        clientId: 'web-app',
        baseUrlOauth2: 'https://test-assets.trask.cz/be/oauth2',
        redirectUrl: 'https://test-assets.trask.cz/web-app/callback'
    },

}
